import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Timing Breakdown panel art: how the day's moves spread across the clock. A
 * small clock glyph sits top left of twelve thin bars that build to a peak in
 * the first third of the session, then tail away into the afternoon.
 */

const BASELINE = 84

/** Bar heights, left to right across the session. */
const HEIGHTS = [10, 22, 38, 50, 44, 36, 30, 24, 20, 16, 12, 8]

export function TimingBreakdownArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <circle
        cx={20}
        cy={20}
        r={7}
        fill="none"
        stroke="hsl(var(--foreground) / 0.4)"
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M20 20 V15 M20 20 L24 22"
        fill="none"
        stroke="hsl(var(--foreground) / 0.5)"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      {HEIGHTS.map((height, index) => {
        const x = 14 + index * 11
        return (
          <rect
            key={x}
            x={x}
            y={BASELINE - height}
            width={7}
            height={height}
            rx={2}
            fill="hsl(var(--primary) / 0.7)"
          />
        )
      })}
      <path
        d={`M12 ${BASELINE} H148`}
        stroke="hsl(var(--muted-foreground) / 0.35)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
